import { defineComponent as _defineComponent } from 'vue'
import { computed, onUnmounted, ref, watch, watchEffect } from 'vue'
import { list as hotItems, show as showHot } from '@/store/hot'
import { list as measureItems } from '@/store/measure'
import { panos as panoItems } from '@/store/panos'
import { main } from '@/store/dataset'
import {
  CoordinateType,
  customMap,
  genUseLoading,
  hotDisabledStack,
  LocalCoord,
  measureDisabledStack,
  useFlyMeasure,
  useParams,
  useSDK,
  useTransform
} from '@/hook'
import { genSingle, linkageSelectTree, LinkageTree, round } from '@/utils'
import { getUnit, infos } from '../measure/constant'
import { CoordType, Pos } from '@/sdk'
import ShowHotItem from '@/components/show-hot-item/index.vue'
import {
  coordTemps,
  defaultCoordTempId,
  mergeCoord,
  requestData
} from '@/store/coord-temp'
import { saveAs } from 'file-saver'
import { TemploraryID } from '@/store'
import { useUploadPropress } from '@/hook/useUploadPropress'
import { coordTypes } from '@/components/coord-type/constant'
import { ui18n } from '@/lang'
import axios, { URL } from '@/request'
import { EPInfo } from '@/request/model'
import { Mode } from '../../sdk/types/sdk'
enum Type {
  hot = 'hot',
  measure = 'measurement',
  pano = 'point',
  ctrls = 'ctrls'
}
const uploadId = '-1'

export default /*#__PURE__*/_defineComponent({
  __name: 'download',
  setup(__props, { expose: __expose }) {
  __expose();

const options = [
  {
    value: Type.hot,
    label: ui18n.t('hotspot.labelName'),
    show: computed(() => map.value[Type.hot]().length > 0)
  },
  {
    value: Type.measure,
    label: ui18n.t('measure.name'),
    show: computed(() => map.value[Type.measure]().length > 0)
  },
  {
    value: Type.pano,
    label: ui18n.t('scene.point'),
    show: computed(() => map.value[Type.pano]().length > 0)
  },
  {
    value: Type.ctrls,
    label: ui18n.t('coord.ctrls'),
    show: computed(() => map.value[Type.ctrls]().length > 0)
  }
]

const mtype = computed(() => {
  const r = Object.entries(coordTypes).find(([key, val]) =>
    val.options.value.some(item => item.value === customMap.coord)
  )
  let t = 'pro'
  if (
    customMap.coord === 'gcj02' ||
    customMap.coord === '__4326' ||
    (r && r[0] === CoordinateType.GIS.toString())
  ) {
    t = 'gis'
  }
  return t
})
const type = ref<Type>(Type.hot)
const laser = useSDK()
watchEffect(() => {
  requestData(type.value, mtype.value).then(res => {
    if (coordTemps.value.length === 1) {
      temp.value = coordTemps.value[0].id
    }
  })
})

const oldMeasureVals = measureItems.value.map(item => {
  const oldVal = item.show
  item.show = true
  return oldVal
})
const oldHotShow = showHot.value
showHot.value = true
onUnmounted(
  genSingle(
    () =>
      measureItems.value.forEach(
        (item, ndx) => (item.show = oldMeasureVals[ndx])
      ),
    measureDisabledStack.push(ref(true)),

    () => (showHot.value = oldHotShow),
    hotDisabledStack.push(ref(true)),
    // hotInfoDisabledStack.push(ref(true)),
    laser.carry.hotTheme.push({
      component: ShowHotItem,
      props: {}
    })
  )
)

watchEffect(
  onCleanup => {
    if (type.value === Type.measure) {
      onCleanup(genSingle(measureDisabledStack.push(ref(false))))
    } else if (type.value === Type.hot) {
      onCleanup(
        genSingle(
          hotDisabledStack.push(ref(false)),
          // hotInfoDisabledStack.push(ref(false)),
          () => {}
        )
      )
    } else {
      onCleanup(() => {})
    }
  },
  { flush: 'sync' }
)

const data = ref<EPInfo>()
axios.post(URL.epInfo).then(res => {
  console.log('URL.epInfo', res)
  data.value = res
})
const edata = ref<any>()
axios
  .post(`/laser/cloudPointEdit/${useParams().m}${`/${main.value.id}`}`, {})
  .then(res => (edata.value = res.data?.sweepLocations || []))
let cts = ref()
axios.post(URL.epControlPonts, {}).then(controls => {
  const laser = useSDK()
  cts.value = controls.map(c => {
    const loc = laser.getPositionByPanoInfo(
      c.uid,
      c.offset.left,
      c.offset.top,
      c.offset.depth
    )
    return loc
  })
})

const map = computed(() => {
  return {
    [Type.hot]: () => {
      return hotItems.value.map(item => ({
        label: item.title,
        datasetIds: [item.datasetId],
        points: [item.pos],
        append: '',
        icon: ''
      }))
    },
    [Type.measure]: () => {
      return measureItems.value.flatMap(item => {
        let bufPoints: Pos[][] = []
        let bufSetIds: string[][] = []
        let u: ReturnType<typeof getUnit> = { origin: '', buffers: [] }
        if (laser.carry.measureMap.get(item)) {
          const cas = laser.carry.measureMap.get(item)
          u = getUnit({ canvas: cas, raw: item })
          bufPoints = cas.getBuffersPoints ? cas.getBuffersPoints() : []
          bufSetIds = cas.getBuffersDatasets ? cas.getBuffersDatasets() : []
        }
        const icon = infos[item.type].icon

        const options = item.buffers.map((buf, ndx) => ({
          icon,
          label: buf.title,
          datasetIds: bufSetIds[ndx],
          points: bufPoints[ndx],
          raw: item,
          append: u.buffers[ndx]
          // icon:
        }))

        options.unshift({
          icon,
          label: item.title,
          datasetIds: item.datasetIds,
          points: item.points,
          append: u.origin,
          raw: item
        })
        return options
      })
    },
    [Type.pano]: () => {
      return panoItems.value.map(pano => ({
        label: pano.label,
        points: [{ x: pano.x, y: pano.y, z: pano.z }],
        datasetIds: [main.value.id],
        append: '',
        icon: ''
      }))
    },
    [Type.ctrls]: () => {
      const options = (data.value?.gis || []).map((item, ndx) => {
        const result = { x: item.pos[0], y: item.pos[1], z: item.pos[2] }
        let point: any

        if (data.value.epsg === 'custom') {
          let p
          if (cts.value[ndx]) {
            p = sdk.coordTransform(
              CoordType.LOCAL,
              cts.value[ndx],
              CoordType.MESH_LOCAL,
              main.value.id
            )
            p = useTransform(LocalCoord.LOCAL, LocalCoord.WGS84, p)
          } else {
            const origin = useTransform(
              LocalCoord.WGS84,
              LocalCoord.WebMercator,
              {
                x: main.value.location[0],
                y: main.value.location[1],
                z: main.value.location[2]
              }
            )
            origin.x += result.x
            origin.y += result.y
            origin.z += result.z
            p = useTransform(LocalCoord.WebMercator, LocalCoord.WGS84, origin)
          }
          result.x = p.x
          result.y = p.y
          result.z = p.z
        }

        point = sdk.coordTransform(
          CoordType.LOCAL,
          useTransform(LocalCoord.WGS84, LocalCoord.LOCAL, result),
          CoordType.MESH_LOCAL,
          main.value.id
        )
        // const mloc = loc
        return {
          label: `${ui18n.t('coord.ctrls') + (ndx + 1)}`,
          points: [point],
          datasetIds: [main.value.id],
          append: '',
          icon: ''
        }
      })

      options.push(
        ...panoItems.value
          .filter(item => {
            if (!item.gis) return
            if (!edata.value) return
            return edata.value.find(a => Number(a.uuid) === item.originId)
              ?.has_rtk
          })
          .map((pano, ndx) => ({
            label: `${ui18n.t('coord.ctrls') + (ndx + 1)}`,
            points: [{ x: pano.x, y: pano.y, z: pano.z }],
            datasetIds: [main.value.id],
            append: '',
            icon: ''
          }))
      )
      return options
    }
  }
})

const coordOptions = computed(() => {
  return map.value[type.value]()
})

const linkTree = ref<LinkageTree<any>>()
watch(
  coordOptions,
  () => {
    const tree = { children: coordOptions.value }
    linkTree.value = linkageSelectTree(tree, false)
    linkTree.value.selects = coordOptions.value as any
  },
  { immediate: true, flush: 'post' }
)

const sdk = useSDK()
const fly = (ndx: number, option: any) => {
  if (type.value === Type.hot) {
    // laser.carry.store.share.showHot = hotItems.value[ndx];
    sdk.scene.comeToHot(hotItems.value[ndx])
  } else if (type.value === Type.measure) {
    const item = measureItems.value[ndx]
    const cas = laser.carry.measureMap.get(item)
    useFlyMeasure(item.points, cas)
  } else if (type.value === Type.pano) {
    const item = panoItems.value[ndx]
    laser.scene.setPose(
      { panoOriginID: item.raw.file_id, datasetId: main.value.id },
      300
    )
  } else if (type.value === Type.ctrls) {
    const position = sdk.coordTransform(
      CoordType.MESH_LOCAL,
      option.points[0] as any,
      CoordType.LOCAL,
      option.datasetIds[0]
    )
    customMap['mode'] = Mode.cloud
    laser.scene.setPose({ position, datasetId: main.value.id } as any, 300)
  }
}

// useDesaveAssist(coordTemps, {
//   auto: true,
//   save: storeSave,
//   intercept: () => {
//     return isLogin.value && inRevise(getBackups(), coordTemps.value);
//   },
//   backup: backups,
//   recovery,
// });

const temp = ref<string>()
const fileInput = ref<any>()
watchEffect(() => {
  if (temp.value === uploadId && fileInput.value) {
    temp.value = void 0
    fileInput.value.vmRef.input.click()
  }
})
const tempOption = computed(() => [
  // { label: "上传模板", value: uploadId },
  ...coordTemps.value.map(item => ({ label: item.title, value: item.id }))
])

const download = genUseLoading(async () => {
  let fileName = ''
  const downItem = async (options, name = '') => {
    const data = options.flatMap(item => {
      return item.points.map((pos, ndx) => {
        if (type.value === Type.pano || type.value === Type.ctrls) {
          pos = useSDK().coordTransform(
            CoordType.MESH_LOCAL,
            pos,
            CoordType.LOCAL,
            item.datasetIds[ndx]
          )
        }

        pos = useTransform(
          LocalCoord.LOCAL,
          customMap.coord,
          pos,
          customMap.coordOutType
        )
        pos.z = round(pos.z, 4)

        let title = ''
        if (type.value !== Type.measure) {
          title =
            (item.label || '') +
            (item.raw ? '-' + infos[item.raw.type].name + '-' + (ndx + 1) : '')
        } else {
          let titles: string[] = []
          if (item.label) {
            titles.push(item.label)
          } else if (item.raw) {
            titles.push(infos[item.raw.type].name)
          }
          titles.push((ndx + 1).toString())
          title = titles.join('-')
        }
        return {
          title,
          longitude: pos.x.toString(),
          latitude: pos.y.toString(),
          altitude: pos.z.toString(),
          fid: ndx + 1
        }
      })
    })

    let t = mtype.value
    const current = tempOption.value.find(item => item.value === temp.value)
    mergeCoord(data, temp.value, current.label, t, name)
  }
  const options = linkTree.value.selects as any
  // if (type.value === Type.measure) {
  //   await Promise.all(options.map((item) => downItem([item], item.label || "")));
  // } else {
  await downItem(options)
  // }
})

const downloadTemp = genUseLoading(async () => {
  const current = tempOption.value.find(item => item.value === temp.value)
  await saveAs(temp.value, current.label + '.xls')
})
const uploadHandler = async (file: File) => {
  const url = await useUploadPropress(file, 'coordTemp').promise
  coordTemps.value.push({
    id: TemploraryID.get(),
    title: file.name,
    url
  })
}
const delHandler = option => {
  const ndx = coordTemps.value.findIndex(item => item.id === option.value)
  coordTemps.value.splice(ndx, 1)
}

const __returned__ = { Type, options, mtype, type, laser, oldMeasureVals, oldHotShow, data, edata, get cts() { return cts }, set cts(v) { cts = v }, map, coordOptions, linkTree, sdk, fly, temp, uploadId, fileInput, tempOption, download, downloadTemp, uploadHandler, delHandler, get defaultCoordTempId() { return defaultCoordTempId }, get ui18n() { return ui18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})